import getLPCRegionLOS from './getLPCRegionLOS'

export default function getOfferStaysFrom(offer: App.Offer | App.OfferSummary): number | undefined {
  const marketedDuration = getLPCRegionLOS(offer)
  if (marketedDuration && (offer.availableDurations?.includes(marketedDuration) ?? offer.packages.some(pkg => pkg.duration === marketedDuration))) {
    return marketedDuration
  }
  return offer.minDuration
}
